import { SET_CURRENCY, SET_INCOGNITO, SET_TRACKING } from 'config/actionTypes'
import {
  CURRENCY_LOCAL_STORAGE,
  INCOGNITO_LOCAL_STORAGE,
} from 'config/constants'

const initialState = {
  tracking: null,
  incognito: Boolean(localStorage.getItem(INCOGNITO_LOCAL_STORAGE)),
  currency: localStorage.getItem(CURRENCY_LOCAL_STORAGE) || 'dollar',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TRACKING:
      return {
        ...state,
        tracking: action.tracking,
      }
    case SET_INCOGNITO:
      return {
        ...state,
        incognito: action.incognito,
      }
    case SET_CURRENCY:
      return {
        ...state,
        currency: action.currency,
      }
    default:
      return state
  }
}
